import { render, staticRenderFns } from "./problem_page.vue?vue&type=template&id=0d35a366&scoped=true"
import script from "./problem_page.vue?vue&type=script&lang=js"
export * from "./problem_page.vue?vue&type=script&lang=js"
import style0 from "./problem_page.vue?vue&type=style&index=0&id=0d35a366&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35a366",
  null
  
)

export default component.exports